import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("um_token", res.token);
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white p-10">
        <Lock className="h-6 w-6" />
        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight">Admin Login</h1>
        <p className="mt-2 text-sm text-muted-foreground">Manage products, orders and settings.</p>
        <Input data-testid="admin-email" type="email" placeholder="admin@upgrademate.com" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-6 rounded-none h-11 border-black/20 focus-visible:ring-black" />
        <Input data-testid="admin-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-3 rounded-none h-11 border-black/20 focus-visible:ring-black" />
        <Button data-testid="admin-login-btn" disabled={loading} className="mt-5 w-full rounded-none h-12 bg-primary text-primary-foreground hover:bg-primary/90">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}</Button>
      </form>
    </div>
  );
}
